import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="0" y="15" rx="4" ry="4" width="60" height="60" />
      <rect x="85" y="32" rx="3" ry="3" width="225" height="6" />
      <rect x="85" y="43" rx="3" ry="3" width="200" height="6" />
    </React.Fragment>
  );
};
